import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import { Box, Flex, Text, Button } from "rebass/styled-components";
import Wrapper from "../Wrapper";
import Card from "../../UI/Card/VerticalCardPremium";
import Link from "../../UI/Link";
import Accordion from "../../UI/Accordion";
import Icon from "../../UI/Icon";
import CardSlider from "../Cards/CardSlider";
import Modal from "../../UI/Modal";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  button.sc-aXZVg.cBchVM {
    display: none !important;
  }
`;

const CardsPremium = ({ data }) => {
  data.cards = data.cards || [];
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);

  const handleCardClick = (card, index) => {
    if (data.showModal && card.link) {
      setSelectedCard(card);
      setSelectedCardIndex(index);
    }
  };

  const handleCloseModal = () => {
    setSelectedCard(null);
    setSelectedCardIndex(null);
  };

  const navigateCards = direction => {
    const totalCards = data.cards.length;
    if (totalCards <= 1) return;
    let newIndex;
    if (direction === "next") {
      newIndex = (selectedCardIndex + 1) % totalCards;
    } else {
      newIndex = (selectedCardIndex - 1 + totalCards) % totalCards;
    }
    setSelectedCard(data.cards[newIndex]);
    setSelectedCardIndex(newIndex);
  };

  if (data.style === "slider") {
    return (
      <Wrapper data={data}>
        <Box mx={[-2, -2, -5]}>
          <CardSlider slidesToShow={parseInt(data.nbCards)}>
            {data.cards.map((card, i) => {
              return (
                <Box key={"card-" + i} p={[2, 2, 5]}>
                  <Card isVertical={data.cardFormat === "vertical"} {...card} />
                </Box>
              );
            })}
          </CardSlider>
        </Box>
      </Wrapper>
    );
  }
  if (data.style === "accordion") {
    return (
      <Wrapper data={data}>
        <Box>
          <Accordion
            items={data.cards.map((card, i) => {
              return {
                title: card.title,
                content: (
                  <Box key={"card-" + i} py={[2, 2, 5]}>
                    <Card
                      isVertical={data.cardFormat === "vertical"}
                      {...card}
                      onClick={() => handleCardClick(card)}
                    />
                  </Box>
                )
              };
            })}
          ></Accordion>
        </Box>
      </Wrapper>
    );
  }
  return (
    <Wrapper data={data}>
      <Flex
        variant="grid"
        justifyContent={
          data.blockSettings.align === "center"
            ? "center"
            : data.blockSettings.align === "right"
              ? "flex-end"
              : ""
        }
      >
        {data.cards.map((card, i) => {
          return (
            <Box
              variant="gridItem"
              key={"card-" + i}
              width={[1, 1 / 2, 1 / parseInt(data.nbCards)]}
              pb={6}
            >
              <Card
                isVertical={data.cardFormat === "vertical"}
                imageOnRight={i % 2 !== 0 && data.style === "listAltenate"}
                {...card}
                onClick={() => handleCardClick(card, i)}
              />
            </Box>
          );
        })}
      </Flex>
      {data.cta && (
        <Flex justifyContent="center" mt={4}>
          <Link href={data.cta.href}>
            <Button variant="base">
              <Text>{data.cta.ctaLabel}</Text>
              <Icon icon="arrow-small-next" size={14} />
            </Button>
          </Link>
        </Flex>
      )}
      <GlobalStyle />
      {selectedCard && data.showModal && (
        <Modal
          isOpen={!!selectedCard}
          height={"100%"}
          onClose={handleCloseModal}
          hideCloseButton={true}
        >
          <Box
            width={["100vw", "100vw", "100vw"]}
            maxWidth="100%"
            padding="30px"
            bg="#F4F2EF"
            sx={{
              minHeight: "100%",
              borderRadius: "4px",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "800px"
              }}
            >
              {selectedCard.image && (
                <Box
                  sx={{
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    marginBottom: "20px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    border: "4px solid white"
                  }}
                >
                  <img
                    src={
                      selectedCard.image?.childImageSharp?.fluid?.src ||
                      selectedCard.image?.publicURL ||
                      ""
                    }
                    alt={selectedCard.title || "Image"}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  />
                </Box>
              )}
              <Box
                dangerouslySetInnerHTML={{ __html: selectedCard.modalContent }}
                sx={{
                  color: "#645546",
                  fontFamily: "Poppins, sans-serif",
                  h3: {
                    color: "#645546",
                    marginBottom: "1rem",
                    fontSize: "1.5rem",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: "600"
                  },
                  h4: {
                    color: "#645546",
                    marginTop: "1.5rem",
                    marginBottom: "0.5rem",
                    fontSize: "1.2rem",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: "500"
                  },
                  p: { marginBottom: "1rem", lineHeight: "1.6", fontFamily: "Poppins, sans-serif" },
                  ul: { paddingLeft: "1.5rem", marginBottom: "1rem" },
                  li: { marginBottom: "0.5rem", fontFamily: "Poppins, sans-serif" },
                  width: "100%"
                }}
              />
            </Box>
            <Flex
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                alignItems: "center",
                flexDirection: ["column", "row"],
                gap: ["30px", "5px"]
              }}
            >
              <Box
                sx={{
                  cursor: "pointer",
                  fontSize: ["28px", "24px"],
                  color: "white",
                  width: ["40px", "32px"],
                  height: ["40px", "32px"],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  background: "rgba(0,0,0,0.7)",
                  order: ["0", "2"],
                  "&:hover": {
                    background: "rgba(0,0,0,0.9)"
                  }
                }}
                onClick={handleCloseModal}
              >
                ✕
              </Box>
              {data.cards.length > 1 && (
                <Flex
                  sx={{
                    flexDirection: ["column", "row"],
                    gap: "10px",
                    display: "flex",
                    order: ["1", "0"]
                  }}
                >
                  <Box
                    sx={{
                      cursor: "pointer",
                      fontSize: ["24px", "20px"],
                      color: "white",
                      width: ["40px", "32px"],
                      height: ["40px", "32px"],
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      background: "rgba(0,0,0,0.7)",
                      marginRight: ["0", "8px"],
                      "&:hover": {
                        background: "rgba(0,0,0,0.9)"
                      }
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      navigateCards("prev");
                    }}
                  >
                    ←
                  </Box>
                  <Box
                    sx={{
                      cursor: "pointer",
                      fontSize: ["24px", "20px"],
                      color: "white",
                      width: ["40px", "32px"],
                      height: ["40px", "32px"],
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      background: "rgba(0,0,0,0.7)",
                      marginRight: ["0", "8px"],
                      "&:hover": {
                        background: "rgba(0,0,0,0.9)"
                      }
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      navigateCards("next");
                    }}
                  >
                    →
                  </Box>
                </Flex>
              )}
            </Flex>
          </Box>
        </Modal>
      )}
    </Wrapper>
  );
};

CardsPremium.propTypes = {
  data: PropTypes.shape({
    blockSettings: PropTypes.shape({
      align: PropTypes.string
    }),
    style: PropTypes.string,
    cardFormat: PropTypes.string,
    nbCards: PropTypes.string,
    showModal: PropTypes.bool,
    cta: PropTypes.shape({
      href: PropTypes.string,
      ctaLabel: PropTypes.string
    }),
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.string,
        image: PropTypes.string,
        link: PropTypes.string,
        modalContent: PropTypes.string
      })
    )
  })
};
export default CardsPremium;

export const fragment = graphql`
  fragment CardsPremiumBlock on MarkdownRemarkFrontmatterBlockscollection {
    style
    cardFormat
    nbCards
    showModal
    cta {
      href
      ctaLabel
    }
    cards {
      title
      image {
        publicURL
        childImageSharp {
          fluid(maxWidth: 800, quality: 64) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      link
      modalContent
      picto {
        publicURL
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`;
